<template>
  <b-col
    cols="12"
    class="mb-3"
    :md="columnAmount"
    v-html="resolveHtml(content)"
  />
</template>

<script>
import RichTextResolver from 'storyblok-js-client/dist/rich-text-resolver.es'

export default {
  props: {
    columnAmount: { type: Number, default: 12 },
    content     : { type: Object, default: null },
  },
  methods: {
    resolveHtml (content) {
      const resolver = new RichTextResolver()
      return resolver.render(content)
    },
  },
}
</script>
